import { IColors } from "../types";

export const lightThemeColors: IColors = {
    "primary-base": "#fff",
    "primary-25": "#fcfcfc",
    "primary-50": "#f5f6f6",
    "primary-100": "#eaeced",
    "primary-200": "#d6d9db",
    "primary-300": "#bcc0c4",
    "primary-400": "#a2a7ab",
    "primary-500": "#8c9093",
    "primary-600": "#777a7e",
    "primary-700": "#64676a",
    "primary-800": "#535658",
    "primary-900": "#3e4042",
    "primary-1000": "#303233",
    "primary-1100": "#262729",
    "primary-1200": "#161617",
    "secondary-25": "#fefdf2",
    "secondary-50": "#fcf7d1",
    "secondary-100": "#fbeca2",
    "secondary-200": "#fdd543",
    "secondary-300": "#f2b70e",
    "secondary-400": "#db9a11",
    "secondary-500": "#c38217",
    "secondary-600": "#ab6b18",
    "secondary-700": "#955817",
    "secondary-800": "#804714",
    "secondary-900": "#63330e",
    "success-25": "#f7fefc",
    "success-50": "#e0fcf5",
    "success-100": "#b8f9eb",
    "success-200": "#68eed6",
    "success-300": "#37d6ba",
    "success-400": "#19bba1",
    "success-500": "#19a18d",
    "success-600": "#1b8879",
    "success-700": "#197368",
    "success-800": "#166057",
    "success-900": "#104842",
    "surface-base": "#fff",
    "surface-25": "#fcfcfc",
    "surface-50": "#f5f6f6",
    "surface-100": "#eaeced",
    "surface-200": "#d6d9db",
    "surface-300": "#bcc0c4",
    "surface-400": "#a2a7ab",
    "surface-500": "#8c9093",
    "surface-600": "#777a7e",
    "surface-700": "#64676a",
    "surface-800": "#535658",
    "surface-900": "#3e4042",
    "surface-1000": "#303233",
    "surface-1100": "#262729",
    "surface-1200": "#161617",
    "tertiary-25": "#fbfdff",
    "tertiary-50": "#eff7fe",
    "tertiary-100": "#dceefe",
    "tertiary-200": "#b7ddfe",
    "tertiary-300": "#7ec7fe",
    "tertiary-400": "#4cadfc",
    "tertiary-500": "#2e90fa",
    "tertiary-600": "#2379dd",
    "tertiary-700": "#2165bf",
    "tertiary-800": "#1e53a3",
    "tertiary-900": "#173d7f",
    "error-25": "#fefcfb",
    "error-50": "#fef3f1",
    "error-100": "#fee8e3",
    "error-200": "#feccc4",
    "error-300": "#fdaba3",
    "error-400": "#fa847b",
    "error-500": "#f45c51",
    "error-600": "#de4032",
    "error-700": "#ba382a",
    "error-800": "#9b3022",
    "error-900": "#742418",
    "text-primary-100": "#eaeced",
    "text-primary-200": "#d6d9db",
    "text-primary-300": "#bcc0c4",
    "text-primary-400": "#a2a7ab",
    "text-primary-500": "#8c9093",
    "text-primary-600": "#777a7e",
    "text-primary-700": "#64676a",
    "text-primary-800": "#535658",
    "text-primary-900": "#3e4042",
    "text-primary-1000": "#303233",
    "text-primary-1100": "#262729",
    "text-primary-1200": "#161617",
    "text-primary-base": "#fff",
    "text-secondary-100": "#fbeca2",
    "text-secondary-200": "#fdd543",
    "text-secondary-300": "#f2b70e",
    "text-secondary-400": "#db9a11",
    "text-secondary-500": "#c38217",
    "text-secondary-600": "#ab6b18",
    "text-secondary-700": "#955817",
    "text-secondary-800": "#804714",
    "text-secondary-900": "#63330e",
    "text-tertiary-100": "#dceefe",
    "text-tertiary-200": "#b7ddfe",
    "text-tertiary-300": "#7ec7fe",
    "text-tertiary-400": "#4cadfc",
    "text-tertiary-500": "#2e90fa",
    "text-tertiary-600": "#2379dd",
    "text-tertiary-700": "#2165bf",
    "text-tertiary-800": "#1e53a3",
    "text-tertiary-900": "#173d7f",
    "text-success-100": "#d1f9a5",
    "text-success-200": "#a2ed62",
    "text-success-300": "#79d62e",
    "text-success-400": "#61bb1d",
    "text-success-500": "#54a11f",
    "text-success-600": "#48891d",
    "text-success-700": "#3c741a",
    "text-success-800": "#326017",
    "text-success-900": "#254810",
    "text-error-100": "#fee8e3",
    "text-error-200": "#feccc4",
    "text-error-300": "#fdaba3",
    "text-error-400": "#fa847b",
    "text-error-500": "#f45c51",
    "text-error-600": "#de4032",
    "text-error-700": "#ba382a",
    "text-error-800": "#9b3022",
    "text-error-900": "#742418",
    "background-primary-25": "#fcfcfc",
    "background-primary-50": "#f5f6f6",
    "background-primary-100": "#eaeced",
    "background-primary-200": "#d6d9db",
    "background-primary-300": "#bcc0c4",
    "background-primary-800": "#535658",
    "background-primary-900": "#3e4042",
    "background-primary-1200": "#161617",
    "background-primary-base": "#fff",
    "background-secondary-25": "#fefdf2",
    "background-secondary-50": "#fcf7d1",
    "background-secondary-100": "#fbeca2",
    "background-secondary-200": "#fdd543",
    "background-secondary-300": "#f2b70e",
    "background-secondary-600": "#ab6b18",
    "background-secondary-700": "#955817",
    "background-secondary-800": "#804714",
    "background-tertiary-25": "#fbfdff",
    "background-tertiary-50": "#eff7fe",
    "background-tertiary-100": "#dceefe",
    "background-tertiary-200": "#b7ddfe",
    "background-tertiary-300": "#7ec7fe",
    "background-tertiary-600": "#2379dd",
    "background-tertiary-700": "#2165bf",
    "background-tertiary-800": "#1e53a3",
    "background-success-25": "#fafef5",
    "background-success-50": "#ebfbd7",
    "background-success-100": "#d1f9a5",
    "background-success-200": "#a2ed62",
    "background-success-300": "#79d62e",
    "background-success-600": "#48891d",
    "background-success-700": "#3c741a",
    "background-success-800": "#326017",
    "background-error-25": "#fefcfb",
    "background-error-50": "#fef3f1",
    "background-error-100": "#fee8e3",
    "background-error-200": "#feccc4",
    "background-error-300": "#fdaba3",
    "background-error-600": "#de4032",
    "background-error-700": "#ba382a",
    "background-error-800": "#9b3022",
    "border-primary-100": "#eaeced",
    "border-primary-200": "#d6d9db",
    "border-primary-300": "#bcc0c4",
    "border-primary-400": "#a2a7ab",
    "border-primary-500": "#8c9093",
    "border-primary-900": "#3e4042",
    "border-primary-1200": "#161617",
    "border-secondary-100": "#fbeca2",
    "border-secondary-200": "#fdd543",
    "border-secondary-300": "#f2b70e",
    "border-secondary-400": "#db9a11",
    "border-secondary-500": "#c38217",
    "border-secondary-700": "#955817",
    "border-secondary-800": "#804714",
    "border-tertiary-100": "#dceefe",
    "border-tertiary-200": "#b7ddfe",
    "border-tertiary-300": "#7ec7fe",
    "border-tertiary-400": "#4cadfc",
    "border-tertiary-500": "#2e90fa",
    "border-tertiary-700": "#2165bf",
    "border-tertiary-800": "#1e53a3",
    "border-success-100": "#d1f9a5",
    "border-success-200": "#a2ed62",
    "border-success-300": "#79d62e",
    "border-success-400": "#61bb1d",
    "border-success-500": "#54a11f",
    "border-success-700": "#3c741a",
    "border-success-800": "#326017",
    "border-error-100": "#fee8e3",
    "border-error-200": "#feccc4",
    "border-error-300": "#fdaba3",
    "border-error-400": "#fa847b",
    "border-error-500": "#f45c51",
    "border-error-700": "#ba382a",
    "border-error-800": "#9b3022",
    "warning-25": "#fefcfa",
    "warning-50": "#fdf4eb",
    "warning-100": "#fbead7",
    "warning-200": "#f8d2ae",
    "warning-300": "#f6b179",
    "warning-400": "#f38c48",
    "warning-500": "#ed6620",
    "warning-600": "#cc5521",
    "warning-700": "#af451f",
    "warning-800": "#95371c",
    "warning-900": "#722715",
    "pink-25": "#fefcfd",
    "pink-50": "#fdf3f9",
    "pink-100": "#fce5f4",
    "pink-200": "#facbea",
    "pink-300": "#f9a5df",
    "pink-400": "#f67ccc",
    "pink-500": "#ef4ebd",
    "pink-600": "#d734a0",
    "pink-700": "#b92882",
    "pink-800": "#9e1e68",
    "pink-900": "#7a134a",
    "purple-25": "#fcfcff",
    "purple-50": "#f5f5fe",
    "purple-100": "#ebebfe",
    "purple-200": "#d7d5fe",
    "purple-300": "#c0b8fe",
    "purple-400": "#a79afc",
    "purple-500": "#917dfa",
    "purple-600": "#7d5ff8",
    "purple-700": "#6c42f2",
    "purple-800": "#5c25e3",
    "purple-900": "#451ea9",
    "green-25": "#fafef5",
    "green-50": "#ebfbd7",
    "green-100": "#d1f9a5",
    "green-200": "#a2ed62",
    "green-300": "#79d62e",
    "green-400": "#61bb1d",
    "green-500": "#54a11f",
    "green-600": "#48891d",
    "green-700": "#3c741a",
    "green-800": "#326017",
    "green-900": "#254810"
};
